var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.225 17.7875L18.1824 15.5L14.225 13.2125V17.7875ZM23.0395 11.8172C23.1386 12.1755 23.2073 12.6559 23.253 13.2659C23.3064 13.8759 23.3293 14.402 23.3293 14.8595L23.375 15.5C23.375 17.1699 23.253 18.3975 23.0395 19.1829C22.8489 19.8692 22.4066 20.3114 21.7204 20.502C21.362 20.6012 20.7063 20.6698 19.6998 20.7155C18.7085 20.7689 17.8011 20.7918 16.9624 20.7918L15.75 20.8375C12.5551 20.8375 10.565 20.7155 9.77963 20.502C9.09338 20.3114 8.65113 19.8692 8.4605 19.1829C8.36138 18.8245 8.29275 18.3442 8.247 17.7342C8.19363 17.1242 8.17075 16.598 8.17075 16.1405L8.125 15.5C8.125 13.8302 8.247 12.6025 8.4605 11.8172C8.65113 11.1309 9.09338 10.6887 9.77963 10.498C10.138 10.3989 10.7938 10.3303 11.8003 10.2845C12.7915 10.2312 13.6989 10.2083 14.5376 10.2083L15.75 10.1625C18.9449 10.1625 20.935 10.2845 21.7204 10.498C22.4066 10.6887 22.8489 11.1309 23.0395 11.8172Z",
    fill: "#DFEC49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.7d35024244f996b1e74c6a719e347497.svg";
export { ForwardRef as ReactComponent };